module.exports = __webpack_public_path__ + "img/builder.9cbc7cfd.jpeg";